import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { AriaLiveTee } from 'components/common/AriaLive';
import { AD_PREFERENCE_COOKIE } from 'constants/cookies';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { fetchAdPreferences, setAdPreferences } from 'actions/account/ads';

import css from 'styles/components/landing/zapposForm.scss';

export const makeTags = ({ tagName, type, value, label, name, required }, setPrefValue, optOutPreference, i) => {
  switch (tagName) {
    case 'input':
      return (
        <p className={css.option} key={`${name}-${i}-${optOutPreference}`}>
          <input
            type={type}
            required={required === 'true' || required === true}
            name={name}
            id={`${name}-${i}`}
            onChange={setPrefValue.bind(this, value)}
            value={value}
            defaultChecked={value === optOutPreference?.toString()}
          />
          <label htmlFor={`${name}-${i}`}>{label}</label>
        </p>
      );
    case 'button':
      /* take type as a property https://github.com/yannickcr/eslint-plugin-react/issues/1846 */
      /* eslint-disable react/button-has-type */
      return (
        <button
          key={`${value}-${i}`}
          className={css.submit}
          type={type}
          value={value}>
          {label}
        </button>
      );
      /* eslint-enable */
  }
};

export const ZapposForm = props => {
  const {
    fetchAdPreferences,
    setAdPreferences,
    className,
    slotDetails,
    ads,
    optOutPreference
  } = props;

  const { type } = slotDetails;

  const [prefValue, setPrefValue] = useState(null);

  useEffect(() => {
    switch (type) {
      case 'AdvertisingPreferences':
        fetchAdPreferences();
    }
  }, [fetchAdPreferences, type]);

  useEffect(() => {
    setPrefValue(optOutPreference);
  }, [optOutPreference]);

  const {
    controls,
    heading,
    successMessage,
    failureMessage,
    action,
    method = 'post'
  } = slotDetails;

  const { err, success } = ads || {};

  const onSubmit = e => {
    e.preventDefault();

    if (typeof prefValue === 'string' || typeof prefValue === 'boolean') {
      setAdPreferences(prefValue);
    }
  };

  return (
    <div className={cn(css.container, className)}>
      <h2>{ heading }</h2>

      {
        !err && success &&
        <AriaLiveTee>
          <p className={css.success}>{successMessage}</p>
        </AriaLiveTee>
      }

      { err &&
        <AriaLiveTee>
          <p className={css.failure}>{failureMessage}</p>
        </AriaLiveTee>
      }

      { /* our custom eslint rule doesnt accept method as a prop */
        /* eslint-disable-next-line marty/form-has-method */ }
      <form onSubmit={onSubmit} method={method} action={action}>
        {controls.map((option, i) => makeTags(option, setPrefValue, optOutPreference, i))}
      </form>
    </div>
  );
};

const mapStateToProps = state => {
  const { cookies, account: { ads } } = state;

  const adPreferenceCookie = cookies[AD_PREFERENCE_COOKIE];
  const adPreferences = adPreferenceCookie ? JSON.parse(adPreferenceCookie) : null;
  const { optOutPreference } = adPreferences || {};

  return {
    ads,
    optOutPreference
  };
};

const mapDispatchToProps = {
  fetchAdPreferences,
  setAdPreferences
};

const ConnectedZapposForm = connect(mapStateToProps, mapDispatchToProps)(ZapposForm);
export default withErrorBoundary('ZapposForm', ConnectedZapposForm);
